import api from "../utils/api.js";
import events from "../utils/events.js";
import {_} from "vue-underscore";
import { trackEvent, eventNames } from '../utils/tracking';
import { OUTFIT_TYPES } from "../../config.js";

export const savedOutfits = {
    namespaced: true,
    state: {
        savedOutfits: [],
        savedOutfitsDataLoading: true,
        savedOutfitsCount: 0,
        savedOutfitCurrent: {},
        filtersOpen: false,
    },
    getters: {
        savedOutfitsCount(state){
            return state.savedOutfitsCount;
        },
        savedOutfitsDataLoading (state) {
            return state.savedOutfitsDataLoading;
        },
        savedOutfits(state){
            return state.savedOutfits;
        },
        totalSavedOutfits(state) {
            return state.savedOutfits.length;
        },
        savedOutfitCurrent(state) {
            return state.savedOutfitCurrent;
        },
        filtersOpen (state) {
            return state.filtersOpen;
        }
    },
    mutations: {
        saveOutfit(state, payload) {
            const { outfit, gaeVersion } = payload;

            state.savedOutfitsCount++;
            state.savedOutfits.push(outfit);

            events.trackEvent(
                'like_outfit',
                {
                    outfitId: outfit.outfit_id,
                    outfitAltered: false,
                    isPersonalized: parseInt(outfit.outfit_featured) == 1 ? false : true,
                    outfitScore: outfit.outfit_score,
                    gaeVersion: gaeVersion,
                }
            );
   
            trackEvent(eventNames.SAVE_OUTFIT, {content_id: outfit.outfit_id, price: outfit.outfit_price});
        },
        rejectOutfit(state, payload) {
            const { outfit, gaeVersion } = payload;

            state.savedOutfits = state.savedOutfits.filter(outfitFilter => outfitFilter.outfit_id !== outfit.outfit_id);

            events.trackEvent(
                'reject_outfit',
                {
                    outfitId: outfit.outfit_id,
                    outfitAltered: false,
                    isPersonalized: parseInt(outfit.outfit_featured) == 1 ? false : true,
                    outfitScore: outfit.outfit_score,
                    gaeVersion: gaeVersion,
                }
            );

            trackEvent("reject_outfit", {content_id: outfit.outfit_id});
        },
        setSavedOutfits(state, outfits) {
            state.savedOutfits = outfits.map(outfit => ({
                ...outfit,
                currentProductIndex: 0,
                type: OUTFIT_TYPES.SAVED,
            }));
            state.savedOutfitsDataLoading = false;
        },
        setSavedOutfitsLoading(state, loading) {
            state.savedOutfitsDataLoading = loading;
        },
        setSavedOutfitsCount(state, count) {
            state.savedOutfitsCount = count;
        },
        setCurrentOutfit(state, outfit) {
            const products = outfit.products.map((product) => {
                if(!state.savedOutfitCurrent.products) {
                    return {
                        ...product,
                        selected: true
                    };
                } 

                const currentProduct = state.savedOutfitCurrent.products.find(currentProduct => currentProduct.product_id === product.product_id) || {};

                return {
                    ...currentProduct,
                    ...product,
                };
            });
            
            state.savedOutfitCurrent = {
                ...outfit,
                products,
            }
        },
        setOutfitProductsSelected(state, payload) {
            _.each(state.savedOutfitCurrent.products, product => {
                product.selected = payload.ids ? payload.ids.includes(product.product_id) : true;
            });
        },
        resetState(state){
            state.savedOutfits = [];
            state.savedOutfitsDataLoading = true;
            state.savedOutfitsCount = 0;
            state.savedOutfitCurrent = {};
        },
        setFiltersOpen (state, payload) {
            state.filtersOpen = payload.open;

        },
        changeOutfitProduct(state, payload) {
            const index = payload.index;
            state.savedOutfitCurrent.products.splice(
                index,
                1,
                Object.assign({}, state.savedOutfitCurrent.products[index], {
                    ...payload.product
                })
            );

            const outfitIndex = state.savedOutfits.findIndex(outfit => outfit.outfit_id === state.savedOutfitCurrent.outfit_id);
            if(outfitIndex >= 0) state.savedOutfits[outfitIndex] = state.savedOutfitCurrent;
        },
        changeCurrentProduct(state, payload) {
            const { currentProductIndex } = payload;

            state.savedOutfitCurrent = {
                ...state.savedOutfitCurrent,
                currentProductIndex,
            };

            const outfitIndex = state.savedOutfits.findIndex(outfit => outfit.outfit_id === state.savedOutfitCurrent.outfit_id);
            if(outfitIndex >= 0) state.savedOutfits[outfitIndex] = state.savedOutfitCurrent;
        },
    },
    actions: {
        scoreOutfit(context, payload) {
            let uri = api.outfitsUri() + "/" + payload.outfit.outfit_id + "/score/";
            (payload.score == 1) ? (uri += "yes") : (uri += "no");

            return api
                .post(uri)
                .then(response => {
                    const gaeVersion = context.rootGetters['generatedOutfits/gaeVersion'];
                    if(payload.score == 1) {                        
                        context.commit({
                            type: 'saveOutfit',
                            outfit: payload.outfit,
                            gaeVersion,
                        });
                    } else {
                        context.commit({
                            type: 'rejectOutfit',
                            outfit: payload.outfit,
                            gaeVersion,
                        });
                    }
                    
                })
                .catch(response => {
                    console.log(response);
                });
        },
        fetchSavedOutfit(context, outfitId) {
            let uri = api.outfitsUri();

            return api
                .get(uri + '/' + outfitId)
                .then(response => {
                    return response.outfit;
                })
                .catch(response => {
                    console.log('error fetching saved outfit');
                });
        },
        fetchSavedOutfits(context, payload) {
            if(payload.soft && context.state.savedOutfits.length) {
                return;
            }

            const { page = 0, addTotal = false } = payload;
            const uri = api.outfitsUri() + "/saved";
            
            // Load filters from filter module
            const { optionValues: product_option_value_ids, pricePercentage: outfit_price_percentage, sort } = context.rootGetters['filters/selectedFilters'];

            return api
                .get(uri, {
                    params: {
                        product_option_value_ids,
                        start: page * 20,
                        limit: 20,
                        addTotal,
                        sort_field_type: sort.type,
                        order: sort.order,
                        outfit_price_percentage,
                    }
                })
                .then(response => {
                    if(!_.isEqual(
                        context.state.savedOutfits.slice(page*20, page*20 + 20).map(outfit => outfit.outfit_id),
                        response.outfits.map(outfit => outfit.outfit_id))
                    ) {
                        context.commit("setSavedOutfits",
                            [
                                ...context.state.savedOutfits.slice(0, page*20), 
                                ...response.outfits, 
                                ...context.state.savedOutfits.slice(page*20+21, context.state.savedOutfits.length)
                            ]
                        );
                        if(response.total) {
                            context.commit('setSavedOutfitsCount', response.total);
                        }
                    }

                    context.commit('setSavedOutfitsLoading', false);

                    return response.outfits;
                })
                .catch(error => {
                    throw error;
                });
        },
        toggleFiltersOpen (context, payload) {
            context.commit('setFiltersOpen', {open: !context.state.filtersOpen});
        },
        fetchSavedOutfitsGlobal: {
            root: true,
            handler (namespacedContext, payload) {
                namespacedContext.dispatch('fetchSavedOutfits', {soft: true})
            }
        },
    }
};
